<template>
  <v-app id="login" class="secondary">
    <v-main class="background">
      <v-container fluid fill-height cl>
        <v-layout align-center="" justify-center="" class="login_bg">
          <v-flex xs12 sm8 md3 lg3>
            <SvgIcon class="p-t-6 p-b-3 mb-2 justify-center" img-styles="width:100%;height:auto;max-width:150px" :icon="Logo"/>
            <v-card class="elevation-1 pa-3" style="min-height: 200px">
              <v-card-text>
                <div class="layout column align-center"></div>

                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit="signIn"
                >
                  <label for="">Username</label>
                  <v-text-field
                    prepend-inner-icon="mdi-account"
                    name="login"

                    ref="emailRef"
                    outlined
                    type="text"
                    class="q-text-field shadow-0 my-2"
                    v-model="user.username"
                    dense
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Username is required']"
                  />

                  <label for="">Password</label>
                  <v-text-field
                    :type="hidePassword ? 'password' : 'text'"
                    :prepend-inner-icon="hidePassword ? 'mdi-eye-off' : 'mdi-eye'"
                    name="password"
                    outlined
                    dense
                    hide-details="auto"
                    id="password"
                    class="q-text-field shadow-0 my-2"
                    ref="passRef"
                    :rules="[(v) => !!v || 'Password is required']"
                    v-model="user.password"
                    @click:prepend-inner="hidePassword = !hidePassword"
                  />
                  <div class="d-flex w-full align-center justify-center mt-4">
                    <v-btn
                        type="submit"
                        elevation="0"
                        @click="signIn"
                        class="white--text blue-color text-capitalize"
                        :loading="loading"
                    >Sign In</v-btn
                    >
                  </div>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Logo from "@/assets/images/logo/qp_logo_white.png";
import SvgIcon from "@/components/Image/SvgIcon.vue";
export default {
  data() {
    return {
      loading: false,
      valid: true,
      hidePassword: true,
      user: {},
      Logo
    };
  },
  components:{
    SvgIcon
  },
  beforeCreate() {
    let token = localStorage.getItem("token");
    if (token) {
      this.$router.push("/dashboard", () => {});
    } else {
      this.$store.commit("logout");
    }
  },
  methods: {
    signIn() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please fill email and password");
        return;
      }
      this.showLoader("Checking..");
      this.$store
        .dispatch("login", this.user)
        .then((res) => {
          if (res.status == 200 && res.data.status) {
            this.hideLoader();
            this.showSuccess("Authentication Success.");
            this.$router.push("/dashboard", () => {});
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
  },
};
</script>
<style scoped>
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.v-main {
  background-color: #000;
}
.v-card {
  display: block;
  border-radius: 15px;
}
.secondary {
  background-color: #000000 !important;
  border-color: #000000 !important;
}
/* .login_bg {
  background-image: url("../../assets/images/krews/loginbg.png");
  background-size: unset;
  background-position: center center;
} */
.login-color {
  font-size: 16px;
  color: #fff !important;
  line-height: 1.2;
  text-transform: uppercase;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  min-width: 160px;
  height: 42px;
  border-radius: 21px;
  background: rgb(164, 69, 178);
  background: linear-gradient(
    90deg,
    rgba(164, 69, 178, 1) 0%,
    rgba(212, 24, 114, 1) 52%,
    rgba(250, 66, 153, 1) 100%
  );
  position: relative;
  z-index: 1;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}
.green-color-txt {
  color: #00b0af;
}
.white-color-txt {
  color: #fff;
  text-align: center;
}
</style>
